<template>
  <div class="tile shadow">
    <energo-widget />
  </div>
</template>

<script>
import EnergoWidget from '@/components/widgets/EnergoWidget';

export default {
  name: 'WidgetTile',
  props: {
    doubleBorder: {
      default: false,
      required: false,
      type: Boolean,
    },
  },
  components: { EnergoWidget },
};
</script>

<style lang="scss" scoped>
.tile {
  border-radius: 5%;
  background-color: white;
}

</style>
